import FavoriteRestaurantIdb from '../../data/favorite-restaurant-idb';
import { createRestaurantItemTemplate } from '../templates/template-creator';

const Like = {
  async render() {
    return `
      <div class="content">
        <h2 class="content__heading">Semua restoran favorit</h2>
        <div id="restaurantList" class="restaurantList">
          <div class="loader"></div>
          <div class="no-restaurant" style="display: none;">Belum ada restoran yang disukai</div>
        </div>
      </div>
    `;
  },

  async afterRender() {
    const restaurants = await FavoriteRestaurantIdb.getAllRestaurants();
    const restaurantsContainer = document.querySelector('#restaurantList');
    const noRestaurantElement = document.querySelector('.no-restaurant');

    const loader = document.querySelector('.loader');
    if (loader) {
      loader.style.display = 'none';
    }

    if (restaurants.length === 0) {
      noRestaurantElement.style.display = 'block';
    } else {
      restaurants.forEach((restaurant) => {
        restaurantsContainer.innerHTML += createRestaurantItemTemplate(restaurant);
      });
    }
  },
};

export default Like;
